<template lang="pug">
  .error(v-if="error") {{ error === 500 ? 'Ресурс недоступен' : 'Ссылка некорректна'  }}. Обратитесь в техническую поддержку.
  div(v-else)
    .b-agreement-page(v-if="comment")
      FormBlock
        CommentTile(:comment="comment" external)
          template(#files v-if="comment.projectFiles.length")
            FileList(:files="comment.projectFiles")
          template(#footer v-if="agreement.answeredAt")
            AgreementTile(:item="agreement")
              template(#files v-if="agreement.answeredAt && agreement.projectFiles.length")
                FileList._files(:files="agreement.projectFiles")
      FormBlock(v-if="agreement && !agreement.answeredAt")
        BaseField(
          type="textarea"
          v-model="field.value"
          :error="field.error"
        )
        FileList._files(:files="files" @remove="removeFile")
        ._buttons
          Btn(label dark)._upload-files
            Icon._icon(name="upload" pointer)
            | Загрузить файлы
            input._input(type="file" hidden multiple @change="onFilesSelected($event.target.files)")
          Btn(@click="submit(false)" grey) Отправить на доработку
          Btn(@click="submit(true)" green) Согласовать
</template>

<script>
import utils from '@/utils/common';
import api from '@/api/agreement';
import { v4 as uuidv4 } from 'uuid';

import EmptyLayout from '@/layouts/Empty.vue';
import FormBlock from '@/components/FormBlock.vue';
import CommentTile from '@/components/CommentTile.vue';
import AgreementTile from '@/components/task/detail/AgreementTile.vue';
import BaseField from '@/components/BaseField.vue';
import FileList from '@/components/FileList.vue';


export default {
  components: { FileList, BaseField, AgreementTile, CommentTile, FormBlock, EmptyLayout },
  data() {
    return {
      comment: null,
      agreement: null,
      error: null,
      uploadingFiles: [],
      field: {
        value: '',
        error: '',
      },
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    files() {
      return [
        ...(this.agreement?.projectFiles ?? []).map(f => ({ ...f, removable: true })),
        ...this.uploadingFiles
      ];
    },
  },
  methods: {
    async loadData() {
      const { extId, token } = this.$route.params;

      const response = await api.fetchExternal(extId, token).catch(e => { this.error = e.status; });
      this.comment = response.comment;
      this.comment.createdAt = utils.convertDateToString(new Date(this.comment.createdAt), 'short', true, false);
      this.agreement = response;
    },
    async submit(isAgreed) {
      const answer = this.field.value;
      this.field.error = '';

      if (!isAgreed && answer.trim() === '') {
        this.field.error = 'Если Вы хотите отправить на доработку, то укажите что Вам не нравится.';
        return;
      }

      const question = isAgreed ? 'Согласовать?' : 'Отправить на доработку?';
      if (!await this.$confirm(`${question} Это действие невозможно отменить.`)) return;

      const { extId, token } = this.$route.params;
      const data = { extId, token, isAgreed, answer };

      await api.answerExternal(data, true);
      await this.loadData();

      this.$alert('Ваш ответ принят!');
    },
    async removeFile(file) {
      const { extId, token } = this.$route.params;
      await api.deleteFileExternal(file.id, extId, token);
      this.agreement.projectFiles = this.agreement.projectFiles.filter(f => f.id !== file.id);
    },
    onFilesSelected(files) {
      const category = this.selectedCategory;
      files.forEach((file) => {
        const uploadingFile = {
          file,
          error: '',
          '@id': uuidv4(),
          progress: 0,
          process: 'waiting',
          removable: true,
          controller: new AbortController(),
        };

        this.uploadingFiles = [uploadingFile, ...this.uploadingFiles];
        this.uploadFile(uploadingFile, category);
      });
    },
    async uploadFile(uploadingFile) {
      if (uploadingFile.file.size > 2147483647) {
        uploadingFile.error = 'Максимальный размер файла 2ГБ'; // eslint-disable-line no-param-reassign
        uploadingFile.process = null; // eslint-disable-line no-param-reassign
        return;
      }

      const progressCallback = (progress) => {
        uploadingFile.progress = progress;                                // eslint-disable-line
        uploadingFile.process = progress > 0 ? 'uploading' : 'waiting';   // eslint-disable-line
      };

      try {
        const { extId, token } = this.$route.params;
        const createdFile = await api.uploadFileExternal(
          extId,
          token,
          uploadingFile.file,
          progressCallback,
          uploadingFile.controller,
        );
        uploadingFile.removable = false; // eslint-disable-line no-param-reassign

        this.uploadingFiles = this.uploadingFiles.filter((item) => item !== uploadingFile);
        this.agreement.projectFiles = [createdFile.data.projectFile, ...this.agreement.projectFiles];
      } catch (e) {
        uploadingFile.process = null; // eslint-disable-line
        uploadingFile.error = 'Ошибка загрузки'; // eslint-disable-line
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.agreement-page {
  width: 940px;
  max-width: 95vw;
  margin: 0 auto;
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;

  &__files {
    margin-top: 30px;
  }

  &__buttons {
    margin-top: 23px;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  &__upload-files {
    margin-right: auto;
  }

  @media (max-width: 1000px) {
    padding: 30px 0;
  }

  @media (max-width: 800px) {
    &__buttons {
      flex-direction: column;
    }

    &__upload-files {
      margin: 0;
    }
  }
}
</style>
